import React from 'react'
import { Link } from 'react-router-dom'
import { Routes, Route } from 'react-router'

export const EpicScreen = () => {
  return (
    <div>
      <h1>EpicScreen</h1>
    </div>
  )
}
